<template>
  <v-list-item
    :href="href"
    :rel="href && href !== '#' ? 'noopener' : undefined"
    :target="href && href !== '#' ? '_blank' : undefined"
    :to="item.to"
    :active-class="isDark ? 'sidebar-active-dark white--text' : 'primary white--text'"
  >
    <v-list-item-icon
      v-if="text"
      class="v-list-item__icon--text"
      v-text="computedText"
    />

    <v-list-item-icon v-else-if="item.icon">
      <v-icon v-text="item.icon" />
    </v-list-item-icon>

    <v-list-item-content v-if="item.title || item.subtitle">
      <v-list-item-title class="d-flex align-center">
        <span v-text="item.title" />
        <v-chip
          v-if="item.badge"
          x-small
          label
          class="ml-auto badge-em-breve"
        >
          {{ item.badge }}
        </v-chip>
      </v-list-item-title>

      <v-list-item-subtitle v-text="item.subtitle" />
    </v-list-item-content>
  </v-list-item>
</template>

<style scoped>
.badge-em-breve {
  background-color: rgba(0, 0, 0, 0.06) !important;
  color: #9E9E9E !important;
  font-size: 9px !important;
  height: 18px !important;
  padding: 0 6px !important;
  border-radius: 4px !important;
  font-weight: 500 !important;
  letter-spacing: 0.3px;
}
</style>

<script>
  import Themeable from 'vuetify/lib/mixins/themeable'

  export default {
    name: 'Item',

    mixins: [Themeable],

    props: {
      item: {
        type: Object,
        default: () => ({
          href: undefined,
          icon: undefined,
          subtitle: undefined,
          title: undefined,
          to: undefined,
        }),
      },
      text: {
        type: Boolean,
        default: false,
      },
    },

    computed: {
      computedText () {
        if (!this.item || !this.item.title) return ''

        let text = ''

        this.item.title.split(' ').forEach(val => {
          text += val.substring(0, 1)
        })

        return text
      },
      href () {
        return this.item.href || (!this.item.to ? '#' : undefined)
      },
    },
  }
</script>
